import { QueryRequest } from '@/utils/QueryRequest';
import getHostForWorkers from '@/utils/getHostForWorkers';

interface EmailHashBody {
  email: string;
}

interface IVerifyRes {
  isValid: boolean;
  email: string;
  isRebuy: boolean;
}

interface VerifyBody {
  email: string;
  campaign: string;
  quizUrl: string;
}

type EmailHashResponse = {
  bgid: string;
};

type VerifyWorkerResponse = {
  result: boolean;
  isRebuy: boolean;
  email?: string;
};

function getVerifyContext() {
  if (typeof window === 'undefined') {
    return {
      campaign: 'Utua-Affiliation',
      quizUrl: '',
    };
  }

  return {
    campaign:
      new URLSearchParams(window.location.search).get('utm_campaign') ||
      'Utua-Affiliation',
    quizUrl: `${window.location.host}${window.location.pathname}`,
  };
}

export async function createEmailHash(email: string): Promise<any> {
  const BASE_URL = `https://id.${getHostForWorkers()}`;
  const hashRequest = new QueryRequest<EmailHashResponse, EmailHashBody>(
    BASE_URL
  );
  hashRequest.addDefaultHeaders();
  return hashRequest.post('', { email: email });
}

export async function verifyEmail(email: string): Promise<IVerifyRes> {
  const BASE_URL = `https://verify.${getHostForWorkers()}`;
  const emailParam = email.toLowerCase();
  const { campaign, quizUrl } = getVerifyContext();

  const verifyRequest = new QueryRequest<VerifyWorkerResponse, VerifyBody>(
    BASE_URL
  );
  verifyRequest.addDefaultHeaders();
  const response = await verifyRequest.post('', {
    email: emailParam,
    campaign,
    quizUrl,
  });

  if ('error' in response) {
    return {
      isValid: false,
      isRebuy: false,
      email: emailParam,
    };
  }

  return {
    isValid: response.result,
    isRebuy: response.isRebuy,
    email: response.email || emailParam,
  };
}
